<button class="back-btn" (click)="goBack()" [attr.aria-label]="'Voltar'">
  <i class="ri-arrow-left-line back-icon"></i>
  <span class="back-label">{{ label }}</span>
</button>
<span class="back-divider"></span>
